import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':fieldReportId'}/fieldReportTypes/${number | ':fieldReportTypeId'}/fieldValue`;

export const ROUTE: RouteDefinition = `${baseRoute}/:fieldReportId/fieldReportTypes/:fieldReportTypeId/fieldValue`;

export const URL = (fieldReportId: number, fieldReportTypeId: number): RouteDefinition => `${baseRoute}/${fieldReportId}/fieldReportTypes/${fieldReportTypeId}/fieldValue`;
